export { default } from './SearchWidget';
